import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core'
import { DatePipe } from '@angular/common'
import { License } from '../../models/license-details'
import { LicenseStatus } from '../../models/license-status'
import { LicenseApptGateway } from '../../gateways/license-appt-gateway'
import { CurrentUserGateway } from '../../../common/gateways/current-user-gateway'
import { CurrentUser } from '../../../common/models/current-user'
import { LicenseDataService } from '../../gateways/license-data-service'
import * as moment from 'moment'
import { AppointmentStatus } from '../../models/appointment-status'
import { Router, ActivatedRoute, Params } from '@angular/router'
import { ValidatedSelectOptionModel as State } from '../../../validations/validated-dropdown.component'
import { ValidatedSelectOptionModel } from '../../../validations/validated-dropdown.component'

import { isMMDDYYYY } from '../../../validations/is-mmddyyyy'
import { PortalGlobals } from '../../../portalglobals'
import { OrgSettingsModel } from '../../../org-management/models/org-settings-model'

@Component({
    selector: 'License',
    templateUrl: 'license-appt.component.html',
    styleUrls: ['license-appt.component.scss']
})
export class LicenseApptComponent implements OnInit {
    currentUser: CurrentUser
    @Input()
    licenseViewModel: License[]
    licensedataModel: License
    licenseInsertModel: License
    licenseEditModel: License
    licensedeleteModel: License
    superGuruAdmin = false
    orgAdminMngr = false
    showActions = false
    saveRow = false
    showConfirmDelete = false
    LicenseStatusId: number
    index: number | null
    checkboxDisable: boolean = true
    allStates: State[]
    allLicenseStatus: LicenseStatus[]
    licenseStatus: LicenseStatus
    allAppointmentStatus: AppointmentStatus[]
    appointStatus: AppointmentStatus
    displayMessage: String
    updateLicense: Boolean
    savedMessage: String
    showMessage: Boolean
    UserProfileID: number
    errorMessage: String
    showErrorMessage: Boolean
    errorMessagesForm: any[]
    validLicenseForm: boolean
    icName: string
    licenseStatusDropDown: ValidatedSelectOptionModel[] = []
    showAppt: boolean
    private buildOptionFromCategories(cmDetail: LicenseStatus): ValidatedSelectOptionModel {
        return {
            value: cmDetail.LicenseStatusID,
            text: cmDetail.LicenseStatus
        }
    }

    @ViewChild('focusableEleBottom', { static: true }) focusableEleBottom: ElementRef

    constructor(
        private currentUserGateway: CurrentUserGateway,
        private licenseApptGateway: LicenseApptGateway,
        private licenseDataService: LicenseDataService,
        private route: ActivatedRoute,
        private _global: PortalGlobals
    ) {
        this.currentUser = {} as CurrentUser
        this.licenseViewModel = {} as License[]
        this.licenseInsertModel = {} as License
        this.licenseEditModel = {} as License
        this.licensedataModel = {} as License
        this.licensedeleteModel = {} as License

        this.errorMessagesForm = []
        this.validLicenseForm = true
    }

    //ValidateDate()
    //{
    //    let dt = moment(LicenseExpirationDate)
    //    this.licenseViewModel[i].LicenseDate = dt.format('MM/DD/YYYY').toString()
    //    if (this.licenseViewModel.LicenseDate !== null) {

    //    }

    //}

    ngOnInit(): void {
        this.getAllAppointment()
        this.currentUserGateway.getCurrentUser().subscribe((model: CurrentUser) => {
            this.currentUser = model
            if (this.currentUser != null) {
                this.getLicenseSettings(model.insuranceCompanyId)

                this.icName = this.currentUser.insuranceCompanyName
                if (this.currentUser.IsGuruAdmin === true || this.currentUser.IsSuperAdminAdmin === true) {
                    this.superGuruAdmin = !this.superGuruAdmin
                    if (this.licenseViewModel.length > 0) {
                        this.licenseViewModel.forEach((licenses) => {
                            licenses.checkboxDisable = true
                            if (this.icName === this._global.insuranceCompanyNameNEJE) {
                                licenses.appoint = false
                                licenses.cfmappoint = false
                                licenses.cfmterminate = false
                                licenses.terminate = false
                            } else {
                                if (licenses.LicenseStatusId === 3 || licenses.LicenseStatusId === 1) {
                                    if (
                                        licenses.AppointmentStatusName === 'Inactive' ||
                                        licenses.AppointmentStatusName === 'Terminated' ||
                                        licenses.AppointmentStatusName === null
                                    ) {
                                        licenses.appoint = true
                                    } else if (licenses.AppointmentStatusName === 'Pending') {
                                        licenses.cfmappoint = true
                                    } else if (licenses.AppointmentStatusName === 'Active') {
                                        licenses.terminate = true
                                    } else if (licenses.AppointmentStatusName === 'TerminationPending') {
                                        licenses.cfmterminate = true
                                    }
                                } else if (licenses.AppointmentStatusName === 'Active') {
                                    licenses.terminate = true
                                } else {
                                    licenses.appoint = false
                                    licenses.cfmappoint = false
                                    licenses.cfmterminate = false
                                    licenses.terminate = false
                                }
                            }
                        })
                    }
                } else if (this._global.currentUser.isOrganizationalAdmin || this._global.currentUser.isOrganizationalManager) {
                    this.orgAdminMngr = !this.orgAdminMngr
                    //Adding for neje
                    if (this.icName === this._global.insuranceCompanyNameNEJE) {
                        if (this.licenseViewModel.length > 0) {
                            this.licenseViewModel.forEach((licenses) => {
                                licenses.checkboxDisable = true
                                licenses.appoint = false
                                licenses.cfmappoint = false
                                licenses.cfmterminate = false
                                licenses.terminate = false
                                this.superGuruAdmin = !this.superGuruAdmin
                            })
                        }
                    }
                }
                if (
                    this._global.currentUser.isOrganizationalAdmin ||
                    this._global.currentUser.isOrganizationalManager ||
                    this._global.currentUser.IsSuperAdminAdmin ||
                    this._global.currentUser.IsSuperAdminorGuruAdmin
                ) {
                    this.showActions = true
                } else {
                    this.showActions = false
                }
            }
        })
        this.index = null
        // this.checkboxDisable = true
        this.showMessage = false

        this.route.params.forEach((params: Params) => {
            if (params['userprofileid']) {
                this.UserProfileID = params['userprofileid']
            }
        })
    }

    getLicenseSettings(insuranceCompanyId: string) {
        this.licenseApptGateway.getFMOSettings(insuranceCompanyId).subscribe((data: OrgSettingsModel[]) => {
            let res = data.find((x) => x.SettingName.toUpperCase() === 'SHOW APPOINTMENT')
            if (res === undefined || res === null) {
                this.showAppt = false
            } else {
                if (res.SettingValue.toUpperCase() === 'YES') {
                    this.showAppt = true
                } else {
                    this.showAppt = false
                }
            }
        })
    }

    editLicense(licenseID: number, index: number, LicenseNumber: number, license: License) {
        license.EditRow = true
        this.index = index
        license.checkboxDisable = false
        this.getAllLicenseStatus()
    }

    saveRowLicense(license: License, index: number) {
        license.EditRow = false
        this.index = index
        this.validLicenseForm = true
        this.errorMessagesForm = []

        this.licenseEditModel.LicenseID = license.LicenseID
        this.licenseEditModel.LicenseNumber = license.LicenseNumber

        // console.log("License " + this.licenseEditModel.LicenseNumber)
        if (
            this.licenseEditModel.LicenseNumber === null ||
            this.licenseEditModel.LicenseNumber === undefined ||
            this.licenseEditModel.LicenseNumber === ''
        ) {
            this.validLicenseForm = false
            this.errorMessagesForm.push('State License # is required')
        }

        if (!isMMDDYYYY(license.LicenseDate)) {
            this.validLicenseForm = false
            this.errorMessagesForm.push('License Expiration Date format should be MM/dd/YYYY')
        }

        if (this.validLicenseForm === true) {
            this.licenseEditModel.LicenseExpirationDate = moment(license.LicenseDate).utc().toDate()
            this.licenseStatus = this.allLicenseStatus.find((x) => x.LicenseStatus === license.Status) || ({} as LicenseStatus)
            this.licenseEditModel.LicenseStatusId = this.licenseStatus.LicenseStatusID
            this.licenseEditModel.StatusDate = moment.utc().toDate()
            this.licenseEditModel.UserProfileID = license.UserProfileID
            this.licenseEditModel.RecordLocked = license.RecordLocked

            this.licenseApptGateway.editLicense(this.licenseEditModel).subscribe((model: License[]) => {
                this.licenseViewModel = model

                if (this.licenseViewModel.length > 0) {
                    this.getAppointmentButtons()
                    this.licenseViewModel.forEach((licenses) => {
                        licenses.checkboxDisable = true
                        if (licenses.LicenseExpirationDate !== null) {
                            licenses.LicenseDate = moment(licenses.LicenseExpirationDate).format('MM/DD/YYYY').toString()
                        }
                        if (licenses.AppointmentExpirationDate !== null) {
                            licenses.ExpirationDate = moment(licenses.AppointmentExpirationDate).format('MM/DD/YYYY').toString()
                        }
                        if (licenses.AppointmentEffectiveDate !== null) {
                            licenses.Effectivedate = moment(licenses.AppointmentEffectiveDate).format('MM/DD/YYYY').toString()
                        }
                    })
                    this.savedMessage = 'License Saved Successfully'
                    this.showMessage = true
                    //this.checkboxDisable = true
                    // this.showErrorMessage = false
                    this.focusableEleBottom.nativeElement.focus()
                }
            })
        } else {
            this.showMessage = false
            license.EditRow = true
        }
    }

    deleteLicense(licenseID: number, UserProfileID: number): void {
        this.showConfirmDelete = true
        this.displayMessage = 'Confirm Delete License as of  ' + this.getdate()
        this.updateLicense = false
        this.licensedeleteModel.LicenseID = licenseID
        this.licensedeleteModel.UserProfileID = UserProfileID
        this.showMessage = false
        this.focusableEleBottom.nativeElement.focus()
    }

    cancelLicense() {
        this.errorMessagesForm = []
        this.focusableEleBottom.nativeElement.focus()

        this.licenseInsertModel.LicenseNumber = ''
        this.licenseInsertModel.LicenseExpirationDate = null
        this.licenseInsertModel.LicenseStatusId = null
        this.licenseInsertModel.StateAbbr = ''
        this.validLicenseForm = true
        this.showMessage = false
        this.showErrorMessage = false
        this.saveRow = !this.saveRow
    }
    saveLicense() {
        this.validLicenseForm = true
        this.errorMessagesForm = []

        this.licenseInsertModel.UserProfileID = this.UserProfileID
        if (this.currentUser !== undefined && this.currentUser !== null) this.licenseInsertModel.OrgID = parseInt(this.currentUser.orgId)

        if (
            this.licenseInsertModel.StateAbbr === null ||
            this.licenseInsertModel.StateAbbr === undefined ||
            this.licenseInsertModel.StateAbbr === '' ||
            this.licenseInsertModel.StateAbbr === ' '
        ) {
            this.validLicenseForm = false
            this.errorMessagesForm.push('License State is required')
        }

        if (
            this.licenseInsertModel.LicenseNumber === null ||
            this.licenseInsertModel.LicenseNumber === undefined ||
            this.licenseInsertModel.LicenseNumber === ''
        ) {
            this.validLicenseForm = false
            this.errorMessagesForm.push('State License # is required')
        }

        if (this.licenseInsertModel.LicenseExpirationDate === null || this.licenseInsertModel.LicenseExpirationDate === undefined) {
            this.validLicenseForm = false
            this.errorMessagesForm.push('License Expiration Date format should be MM/dd/YYYY')
        } else {
            if (!isMMDDYYYY(this.licenseInsertModel.LicenseExpirationDate.toString())) {
                this.validLicenseForm = false
                this.errorMessagesForm.push('License Expiration Date format should be MM/dd/YYYY')
            }
        }

        if (
            this.licenseInsertModel.LicenseStatusId === null ||
            this.licenseInsertModel.LicenseStatusId === undefined ||
            parseInt(this.licenseInsertModel.LicenseStatusId.toString()) === 0
        ) {
            this.validLicenseForm = false
            this.errorMessagesForm.push('License Status is required')
        }

        if (this.validLicenseForm === true) {
            this.licenseInsertModel.StatusDate = moment.utc().toDate()
            this.licenseApptGateway.saveLicense(this.licenseInsertModel).subscribe((model: License[]) => {
                this.licenseViewModel = model
                if (this.licenseViewModel.length > 0) {
                    this.getAppointmentButtons()
                    this.licenseViewModel.forEach((licenses) => {
                        licenses.checkboxDisable = true
                        if (licenses.LicenseExpirationDate !== null) {
                            licenses.LicenseDate = moment(licenses.LicenseExpirationDate).format('MM/DD/YYYY').toString()
                        }
                        if (licenses.AppointmentExpirationDate !== null) {
                            licenses.ExpirationDate = moment(licenses.AppointmentExpirationDate).format('MM/DD/YYYY').toString()
                        }
                        if (licenses.AppointmentEffectiveDate !== null) {
                            licenses.Effectivedate = moment(licenses.AppointmentEffectiveDate).format('MM/DD/YYYY').toString()
                        }
                    })
                    this.savedMessage = 'License Saved Successfully'
                    this.showMessage = true
                    this.focusableEleBottom.nativeElement.focus()

                    this.licenseInsertModel.LicenseNumber = ''
                    this.licenseInsertModel.LicenseExpirationDate = null
                    this.licenseInsertModel.LicenseStatusId = 0
                    this.licenseInsertModel.StateAbbr = ' '
                    this.showErrorMessage = false
                    this.saveRow = !this.saveRow
                }
            })
        } else {
            this.showMessage = false
        }
    }

    addNewRow(): void {
        this.saveRow = !this.saveRow
        if (this.UserProfileID !== undefined && this.UserProfileID !== 0) this.getStates(this.UserProfileID)
        else this.getUserStatesForLicense()
        this.getAllLicenseStatus()
    }
    deleteLicenseData(): void {
        if (this.licensedeleteModel !== undefined) {
            this.licenseApptGateway
                .deleteLicense(this.licensedeleteModel.LicenseID || 0, this.licensedeleteModel.UserProfileID || 0)
                .subscribe((model: License[]) => {
                    this.licenseViewModel = model
                    if (this.licenseViewModel.length > 0) {
                        this.getAppointmentButtons()
                        this.licenseViewModel.forEach((licenses) => {
                            licenses.checkboxDisable = true
                            if (licenses.LicenseExpirationDate !== null) {
                                licenses.LicenseDate = moment(licenses.LicenseExpirationDate).format('MM/DD/YYYY').toString()
                            }
                            if (licenses.AppointmentExpirationDate !== null) {
                                licenses.ExpirationDate = moment(licenses.AppointmentExpirationDate).format('MM/DD/YYYY').toString()
                            }
                            if (licenses.AppointmentEffectiveDate !== null) {
                                licenses.Effectivedate = moment(licenses.AppointmentEffectiveDate).format('MM/DD/YYYY').toString()
                            }
                        })
                        this.showMessage = true
                        this.savedMessage = 'License Deleted Successfully'
                        this.focusableEleBottom.nativeElement.focus()
                    }
                })
        }

        this.showConfirmDelete = false
    }

    updateLicenseStatus(): void {
        if ((this.showConfirmDelete = true)) {
            if (this.licenseInsertModel.LicenseID === undefined || this.licenseInsertModel.LicenseID === null) {
                this.licenseApptGateway.updateStatusofLicense(this.licensedataModel).subscribe((data: License[]) => {
                    this.licenseViewModel = data
                    if (this.licenseViewModel.length > 0) {
                        this.getAppointmentButtons()
                        this.licenseViewModel.forEach((licenses) => {
                            licenses.checkboxDisable = true
                            if (licenses.LicenseExpirationDate !== null) {
                                licenses.LicenseDate = moment(licenses.LicenseExpirationDate).format('MM/DD/YYYY').toString()
                            }
                            if (licenses.AppointmentTerminationDate !== null) {
                                licenses.ExpirationDate = moment(licenses.AppointmentTerminationDate).format('MM/DD/YYYY').toString()
                            }
                            if (licenses.AppointmentEffectiveDate !== null) {
                                licenses.Effectivedate = moment(licenses.AppointmentEffectiveDate).format('MM/DD/YYYY').toString()
                            }
                        })
                    }
                    this.showMessage = false
                    this.showConfirmDelete = false
                })
            } else {
                this.licenseApptGateway.addAppointment(this.licenseInsertModel).subscribe((data: License[]) => {
                    this.licenseViewModel = data
                    if (this.licenseViewModel.length > 0) {
                        this.getAppointmentButtons()
                        this.licenseViewModel.forEach((licenses) => {
                            if (licenses.LicenseExpirationDate !== null) {
                                licenses.checkboxDisable = true
                                licenses.LicenseDate = moment(licenses.LicenseExpirationDate).format('MM/DD/YYYY').toString()
                            }
                            if (licenses.AppointmentTerminationDate !== null) {
                                licenses.ExpirationDate = moment(licenses.AppointmentTerminationDate).format('MM/DD/YYYY').toString()
                            }
                            if (licenses.AppointmentEffectiveDate !== null) {
                                licenses.Effectivedate = moment(licenses.AppointmentEffectiveDate).format('MM/DD/YYYY').toString()
                            }
                        })
                    }
                })
                this.licenseInsertModel.LicenseID = null
                this.licenseInsertModel.UserProfileID = null
                this.licenseInsertModel.AppointmentEffectiveDate = null
                this.licenseInsertModel.AppointmentDataSource = null
                this.licenseInsertModel.AppointmentStatusId = null
                this.showMessage = false
                this.showConfirmDelete = false
            }
        }
    }

    appointLicense(licenseID: number, userProfileID: number, appointmentStatusName: string) {
        if (appointmentStatusName !== null) {
            this.appointStatus = this.allAppointmentStatus.find((x) => x.AppointmentStatusName === 'Pending') || ({} as AppointmentStatus)
            this.licensedataModel.LicenseID = licenseID
            this.licensedataModel.UserProfileID = userProfileID
            this.licensedataModel.AppointmentEffectiveDate = moment.utc().toDate()
            this.licensedataModel.AppointmentStatusId = this.appointStatus.AppointmentStatusId
            this.licensedataModel.AppointmentTerminationDate = null
            this.licensedataModel.AppointmentDataSource = 'AgentPortal'
            this.licenseDataService.sendData(this.licensedataModel)
        } else {
            this.appointStatus = this.allAppointmentStatus.find((x) => x.AppointmentStatusName === 'Pending') || ({} as AppointmentStatus)
            this.licenseInsertModel.LicenseID = licenseID
            this.licenseInsertModel.UserProfileID = userProfileID
            this.licenseInsertModel.AppointmentEffectiveDate = moment.utc().toDate()
            this.licenseInsertModel.AppointmentDataSource = 'AgentPortal'
            this.licenseInsertModel.AppointmentStatusId = this.appointStatus.AppointmentStatusId
            this.licenseDataService.sendData(this.licenseInsertModel)
        }
        this.showConfirmDelete = false
        this.updateLicense = true
        this.displayMessage = 'Confirm Your Appoint License as on  ' + this.getdate()
        this.showMessage = false
        this.focusableEleBottom.nativeElement.focus()
        this.updateLicenseStatus()
    }

    confirmappointLicense(licenseID: number, userProfileID: number): void {
        this.appointStatus = this.allAppointmentStatus.find((x) => x.AppointmentStatusName === 'Active') || ({} as AppointmentStatus)
        this.licensedataModel.LicenseID = licenseID
        this.licensedataModel.UserProfileID = userProfileID
        this.licensedataModel.AppointmentStatusId = this.appointStatus.AppointmentStatusId
        this.licensedataModel.AppointmentTerminationDate = null
        this.licenseDataService.sendData(this.licensedataModel)
        this.showConfirmDelete = false
        this.updateLicense = true
        this.displayMessage = 'Confirm Your Appoint License as on  ' + this.getdate()
        this.showMessage = false
        this.focusableEleBottom.nativeElement.focus()
        this.updateLicenseStatus()
    }

    terminateLicense(licenseID: number, userProfileID: number): void {
        this.appointStatus = this.allAppointmentStatus.find((x) => x.AppointmentStatusName === 'TerminationPending') || ({} as AppointmentStatus)
        this.licensedataModel.LicenseID = licenseID
        this.licensedataModel.UserProfileID = userProfileID
        this.licensedataModel.AppointmentTerminationDate = moment.utc().toDate()
        this.licensedataModel.AppointmentStatusId = this.appointStatus.AppointmentStatusId
        this.licenseDataService.sendData(this.licensedataModel)
        this.showConfirmDelete = true
        this.updateLicense = true
        this.showMessage = false
        this.displayMessage = 'Requesting to terminate appointment on  ' + this.getdate()
        //this.displayMessage = 'Confirm Your Terminate License as on  ' + this.getdate()
        this.focusableEleBottom.nativeElement.focus()
    }

    cfmterminateLicense(licenseID: number, userProfileID: number): void {
        this.appointStatus = this.allAppointmentStatus.find((x) => x.AppointmentStatusName === 'Terminated') || ({} as AppointmentStatus)
        this.licensedataModel.LicenseID = licenseID
        this.licensedataModel.UserProfileID = userProfileID
        this.licensedataModel.AppointmentStatusId = this.appointStatus.AppointmentStatusId
        this.licenseDataService.sendData(this.licensedataModel)
        this.showConfirmDelete = true
        this.updateLicense = true
        this.showMessage = false
        this.displayMessage = 'Confirm your request to terminate appointment on  ' + this.getdate()
        //this.displayMessage = 'Confirm Your Terminate License as on  ' + this.getdate()
        this.focusableEleBottom.nativeElement.focus()
    }

    cancelStatusUpdate() {
        this.showMessage = false
        this.showConfirmDelete = false
    }

    getStates(userProfileID: number) {
        this.licenseApptGateway.getAllStates(this.UserProfileID).subscribe((model: State[]) => {
            this.allStates = model
            this.allStates.unshift({ value: ' ', text: ' ' })
            this.licenseInsertModel.StateAbbr = ' '
            console.log(this.allStates)
        })
    }

    getUserStatesForLicense() {
        this.licenseApptGateway.getUserStatesForLicense().subscribe((model: State[]) => {
            this.allStates = model
            this.allStates.unshift({ value: ' ', text: ' ' })
            this.licenseInsertModel.StateAbbr = ' '
            console.log(this.allStates)
        })
    }

    getAllLicenseStatus() {
        this.licenseApptGateway.getAllLicenseStatus().subscribe((model: LicenseStatus[]) => {
            this.allLicenseStatus = model
            this.allLicenseStatus.unshift({ LicenseStatusID: 0, LicenseStatus: ' ' })
            this.licenseInsertModel.LicenseStatusId = 0
            this.licenseStatusDropDown = model.map(this.buildOptionFromCategories.bind(this))
        })
    }

    trackAllLicenseStatus(index, item) {
        return item.LicenseStatusID
    }

    trackLicenseViewModel(index, item) {
        return item.LicenseNumber
    }

    getAllAppointment() {
        this.licenseApptGateway.getAllAppointment().subscribe((model: AppointmentStatus[]) => {
            this.allAppointmentStatus = model
        })
    }

    getAppointmentButtons() {
        this.licenseViewModel.forEach((licenses) => {
            if (this.icName === this._global.insuranceCompanyNameNEJE) {
                licenses.appoint = false
                licenses.cfmappoint = false
                licenses.cfmterminate = false
                licenses.terminate = false
            } else {
                if (licenses.LicenseStatusId === 3 || licenses.LicenseStatusId === 1) {
                    if (
                        licenses.AppointmentStatusName === 'Inactive' ||
                        licenses.AppointmentStatusName === 'Terminated' ||
                        licenses.AppointmentStatusName === null
                    ) {
                        licenses.appoint = true
                    } else if (licenses.AppointmentStatusName === 'Pending') {
                        licenses.cfmappoint = true
                    } else if (licenses.AppointmentStatusName === 'Active') {
                        licenses.terminate = true
                    } else if (licenses.AppointmentStatusName === 'TerminationPending') {
                        licenses.cfmterminate = true
                    }
                } else if (licenses.AppointmentStatusName === 'Active') {
                    licenses.terminate = true
                } else {
                    licenses.appoint = false
                    licenses.cfmappoint = false
                    licenses.cfmterminate = false
                    licenses.terminate = false
                }
            }
        })
    }
    getdate(): string {
        let today = new Date()
        let dt = moment(today)
        let date = dt.format('MM/DD/YYYY').toString()
        return date
    }
}
